export default {
    it: {
        "related-questions": "Domande correlate:",
        "read-all": "Leggi tutto"
    },
    en: {
        "related-questions": "Related questions:",
        "read-all": "Read all"
    }
}